import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {Eye, EyeOff} from 'lucide-react';
import Input from "../props/inputProp";
import { patchDataRaw } from '../fetchRoutes/patchDataRaw';
import { passwordValidation } from '../utility/validation';

export default function UpdatePasswordPage() {

    const navigate = useNavigate();
    const location = useLocation();

    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [samePassword, setSamePassword] = useState(true);
    const [disable, setDisable] = useState(false);
    
    


    const updatePasswordUrl = process.env.REACT_APP_UPDATE_PASSWORD;

    // Handle password change
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'newPassword') {
            setNewPassword(value);
        } else if (name === 'confirmPassword') {
            setConfirmPassword(value);
        }
    };

      // Extract token from the query string
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tokenFromUrl = params.get('token');
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        } else {
            setErrorMessage('Invalid or expired token');
        }
    }, [location]);

    // Password validation checks
        useEffect(() => {
            
        
            if (!newPassword.length || !confirmPassword.length) {
                setSamePassword(true);
                setDisable(true);
            } else if (!passwordValidation(newPassword)) {
                setErrorMessage('Password requires symbols, numbers, and uppercase');
                setSamePassword(false);
                setDisable(true);
            }else if(newPassword !== confirmPassword) {
                setErrorMessage('Passwords does not match!');
                setSamePassword(false);
                setDisable(true);
    
            }else {
                setErrorMessage('');
                setSamePassword(true);
                setDisable(false);
            }
        }, [newPassword, confirmPassword, samePassword, disable]);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
    

        (async ()=>{
            try {
                const response = await patchDataRaw(`${updatePasswordUrl}?token=${token}`, {newPassword});

                if (response.status === 'Success') {
                    setSuccessMessage('You can now login with your new password.');

                    setTimeout(() => {
                        setSuccessMessage('');
                        setErrorMessage('');
                        navigate('/account/login')
                    }, 4000);

                } else {
                    setErrorMessage('Failed to update password');
                    setTimeout(() => {
                        setErrorMessage('');
                    }, 2000);

                }
            } catch (err) {
                console.error('Error:', err);
                setErrorMessage('Something went wrong');
                setTimeout(() => {
                    setErrorMessage('');
                }, 2000);

            }
        })();

    };

    return (
        <main className="home updatePasswordPage">
            <div className="loginContainer">
                {/* Company Logo */}
                <div className="loginLogoContainer">
                    <div className="formTitle">
                        <p className="logInTitle">Update Your Password</p>
                    </div>
                </div>

                {/* Update password form container */}
                <div className="loginFormContainer">
                    <form className="loginForm" onSubmit={handleSubmit}>
                        {/* New Password Input */}
                        <div className="inputs">
                            <label className="label passwordInputs">
                                <div className="passwordLabelDetail">
                                    New Password<span className="asterisk"> *</span>
                                </div>
                                <div className="eyeContainer">
                                    <span 
                                        className="showHideIcon" 
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                </div>
                            
                            </label>
                            <Input
                                className={samePassword ? "password" : "password error"}
                                type={showPassword ? "text" : "password"}
                                name="newPassword"
                                placeholder="........"
                                required
                                minLength="8"
                                value={newPassword}
                                onChange={handleChange}
                                autoComplete="new-password"
                            />
                        </div>

                        {/* Confirm Password Input */}
                        <div className="inputs">
                            <label className="label passwordInputs">
                                <div className="passwordLabelDetail">
                                    Confirm Password<span className="asterisk"> *</span>
                                </div>
                                <div className="eyeContainer">
                                    <span 
                                        className="showHideIcon" 
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                </div>
                            
                            </label>

                            <Input
                                className={samePassword ? "password confirmPassword" : "password  confirmPassword error"}
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                placeholder="........"
                                required
                                minLength="8"
                                value={confirmPassword}
                                onChange={handleChange}
                                autoComplete="new-password"

                            />
                        </div>

                        {/* Error Message */}
                        <div className="errorMessage passwordError">
                                <span className={`errorMessage ${successMessage? 'successMessage passwordSuccess': ''}`}>{errorMessage ? errorMessage : ''} {successMessage ? successMessage : ''}</span>
                        </div>

                        {/* Update Button */}
                        <div className="lButton">
                            <button className="loginButton  updatePasswordButton" type="submit" disabled={disable}> Update Password </button>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    );
}
